"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useBoardSubscription = useBoardSubscription;
const react_1 = require("react");
function useBoardSubscription(board) {
    (0, react_1.useSyncExternalStore)(board.subscribe, board.getSnapshot);
    return board;
}
